import React from "react";
import { FieldInputProps, FieldMetaProps, FastField, Field, FieldArray, ArrayHelpers } from "formik";
import colors from "../../constants/colors";
import { InputOptions, SelectOption } from "./InputOptions";
import { FormikInputProps } from "./FormikInputProps";

import { Checkbox, FormControlLabel, FormControl, FormLabel, FormGroup } from "@material-ui/core";

const styles = {
	formControl: {
		marginRight: 16,
		marginBottom: 24,
	},
	formControlLabel: {
		fontSize: ".75rem",
		margin: 0,
		marginBottom: 10,
		textTransform: "uppercase" as any,
		color: colors.gray600,
	},
};

export const FormikCheckboxInput = (props: FormikInputProps) => {
	const createFormikProps = (
		name: string,
		option: SelectOption,
		arrayHelpers: ArrayHelpers,
		changeHandler: null | ((e: React.ChangeEvent<any>) => void) = null,
	) => {
		return {
			id: name,
			name: name,
			value: option.val,
			checked: props.field.value!.indexOf(option.val) > -1 || false,
			onChange: (e: React.ChangeEvent<any>) => {
				if (changeHandler) {
					changeHandler(e);
				}

				if (e.target.checked) {
					arrayHelpers.push(option.val);
				} else {
					const idx = props.field.value.indexOf(option.val);
					arrayHelpers.remove(idx);
				}
			},
			onBlur: props.field.onBlur,
		};
	};

	const attrs: any = {
		disabled: !!props.options.disabled,
	};

	return (
		<FieldArray
			name="productTierIds"
			render={(arrayHelpers: ArrayHelpers) => (
				<FormControl style={styles.formControl}>
					<FormLabel style={styles.formControlLabel}>{props.options.label}</FormLabel>
					<FormGroup>
						{props.options.selectOptions!.map((option) => (
							<FormControlLabel
								key={option.val}
								control={
									<Checkbox
										{...attrs}
										{...createFormikProps(props.field.name, option, arrayHelpers, props.options.changeHandler)}
									/>
								}
								label={option.text}
							/>
						))}
					</FormGroup>
				</FormControl>
			)}
		/>
	);
};

export const renderFormikCheckboxInput =
	(options: InputOptions) =>
	({ field, meta }: { field: FieldInputProps<any>; meta: FieldMetaProps<any> }) => (
		<FormikCheckboxInput field={field} meta={meta} options={options} />
	);

export const OptimizedFormikCheckboxInputField = (options: InputOptions) => (
	<>
		{options.optimized ? (
			<FastField name={options.name}>{renderFormikCheckboxInput(options)}</FastField>
		) : (
			<Field name={options.name}>{renderFormikCheckboxInput(options)}</Field>
		)}
	</>
);

export const FormikCheckboxInputField = React.memo(OptimizedFormikCheckboxInputField);
